<template>
  <b-card no-body class="card-accent-primary">
    <div slot="header" class="cursor-pointer" @click="filterAccordionVisible = !filterAccordionVisible">
      <b-row>
        <b-col>
          <div class="mt-1 table-title">Búsqueda de Cartera</div>
        </b-col>
        <b-col class="text-right">
          <i class="fa fa-chevron-up" v-if="filterAccordionVisible"></i>
          <i class="fa fa-chevron-down" v-else></i>
        </b-col>
      </b-row>
    </div>
    <b-collapse id="accordion-filter" v-model="filterAccordionVisible" accordion="accordion-filter" role="tabpanel">
      <b-card-body>
        <b-row v-bind:style="{ 'padding-bottom': selectProductoresOpenSize + 'px'}">
          <b-col sm="3">
            <b-card no-body class="btn-table-group">
              <b-button :variant="isProp(0) ? 'success' : 'secondary'" class="mb-1" block @click="setProp(0, 'Pólizas y Endosos')">Pólizas y Endosos </b-button>
              <b-button :variant="isProp(1) ? 'success' : 'secondary'" class="mb-1" block @click="setProp(1, 'Pólizas a Vencer')">Pólizas a Vencer </b-button>
              <b-button :variant="isProp(2) ? 'success' : 'secondary'" class="mb-1" block @click="setProp(2, 'Refacturaciones')">Refacturaciones </b-button>
              <b-button :variant="isProp(3) ? 'success' : 'secondary'" class="mb-1" block @click="setProp(3, 'Pólizas con Deuda')">Pólizas con Deuda </b-button>
              <b-button :variant="isProp(4) ? 'success' : 'secondary'" class="mb-1" block @click="setProp(4, 'Pólizas Anuladas')">Pólizas Anuladas </b-button>
            </b-card>
          </b-col>
          <b-col sm="9">
            <b-card>
              <finder v-model="value.search" :ventana="ventanaActual.cod" :checkboxPadre="value.checkDniCuitCuil" @enter="dispatchSearch" @checkChanged="checkboxChanged"/>
              <h6 class="mini-title mt-5">Filtrar por:</h6>
              <b-form-row>
                <!--b-col :sm="isOrg ? 6 : 12">
                  <b-form-group label="Grupo de Endoso">                    
                    <b-form-select
                      v-model="tiposDeEndoso"
                      :options="tiposEndoso"
                    ></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col :sm="isOrg ? 6 : 12">
                  <b-form-group label="Tipo de Endoso">                    
                    <b-form-select
                      v-model="value.tipoendoso"
                      :options="tiposDeEndoso"
                    ></b-form-select>
                  </b-form-group>
                </b-col-->

                <b-col :sm="isOrg ? 6 : 12">
                  <b-form-group label="Ramo">
                    <!-- Usuario del Grupo Norte no puede elegir otro ramo que RC PROF -->
                    <b-form-select :disabled="isRamoDisabled" :options="ramosHabilitados" v-model="value.ramo"></b-form-select>
                  </b-form-group>
                </b-col>

                <b-col :sm="isOrg ? 6 : 12" v-if="!fechasRefacturaciones">
                  <b-form-group label="Subramo" :disabled="value.ramo && !$role(['grupo norte']) ? false : true">
                    <!-- El resto de los usuarios -->
                    <b-form-select
                      v-model="value.subramo"
                      :options="value.ramo == 'seguro_personas' ? tipoRamos.seg_personas : value.ramo == 'property' ? tipoRamos.property : tipoRamos.rc_profesional"
                    ></b-form-select>
                  </b-form-group>
                </b-col>
                
                <b-col v-if="isEmpInt" sm="6">
                  <b-form-group label="Organizador">

                    <!-- <autocomplete
                      ref="productorAutocomplete"
                      :data="productores"
                      input-class="form-control"
                      loadingCaption="Cargando productores ..."
                      :placeholder="nombreProductor || 'Buscar productor ...'"
                      :loading="!productores"
                      @selected="setProductor"
                      :minLength="0"
                    ></autocomplete> -->


                    <!-- <b-select :options="productores" @change="setProductor" v-model="value.cod_agente">
                      <template>
                        <b-form-select :value="null" disabled>-- Seleccione Productor --</b-form-select>
                      </template>
                    </b-select> -->

                    <v-select
                      :options="organizadores"
                      :reduce="organizadores => organizadores.value"
                      v-model="value.cod_organizador"
                      @input="setOrganizador"
                      @open="onOpen"
                      @close="onClose"
                      label="text"
                    >
                      <template v-slot:option="option">                        
                        <b v-if="option.fav"> {{option.text}} </b>
                        <span v-else>{{option.text}}</span>
                      </template>                      
                    </v-select>

                  </b-form-group>
                </b-col>
                <b-col v-if="isOrg" sm="6">
                  <b-form-group label="Productor">

                    <v-select
                      :options="productores"
                      :reduce="productores => productores.value"
                      v-model="value.cod_agente"
                      @input="setProductor"
                      @open="onOpen"
                      @close="onClose"
                      label="text"
                      :clearable="clearable"
                    >
                      <template v-slot:option="option">                        
                        <b v-if="option.fav"> {{option.text}} </b>
                        <span v-else>{{option.text}}</span>
                      </template>
                    </v-select>

                  </b-form-group>
                </b-col>
              </b-form-row>
              <div v-if="mostrarFechas">
                <b-form-row v-if="!fechasRefacturaciones">
                  <b-col sm="6">
                    <b-form-group label="Vigencia Desde">
                      <b-form-input type="date" v-model="value.vig_desde" :min="minDate" :disabled="disableFecVig || disableFecVigDesde" />
                    </b-form-group>
                  </b-col>
                  <b-col sm="6">
                    <b-form-group label="Vigencia Hasta">
                      <b-form-input type="date" v-model="value.vig_hasta" :disabled="disableFecVig" />
                    </b-form-group>
                  </b-col>
                  <b-col sm="6" v-if="!disableFecEmi">
                    <b-form-group label="Fecha de Emisión desde">
                      <b-form-input type="date" v-model="value.fec_emi_desde" :min="minDate" :disabled="disableFecEmi" />
                    </b-form-group>
                  </b-col>
                  <b-col sm="6" v-if="!disableFecEmi">
                    <b-form-group label="Fecha de Emisión hasta">
                      <b-form-input type="date" v-model="value.fec_emi_hasta" :disabled="disableFecEmi" />
                    </b-form-group>
                  </b-col>
                </b-form-row>

                <!-- inputs de fechas para consulta de refacturaciones -->
                <b-form-row v-else>
                  <b-col sm="6">
                    <b-form-group label="Desde">
                      <b-form-input type="date" v-model="value.refac_desde" @change="reacciona()"></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col sm="6">
                    <b-form-group label="Hasta">
                      <b-form-input type="date" v-model="value.refac_hasta" @change="reacciona()"></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-form-row>
              </div>
              <p v-if="isProp(3)">Nota : Este apartado nos listara todas las polizas con deuda vencida al dia de hoy</p>
              <b-row class="mt-3">
                <b-col sm="3" offset-sm="3" class="text-center">
                  <b-button class="mb-2" variant="secondary" block @click="resetFilters()">Borrar Filtros</b-button>
                </b-col>
                <b-col sm="3" class="text-center">
                  <b-button class="mb-2" variant="primary" block @click="dispatchSearch" :disabled="okDisabled()">Aceptar</b-button>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </b-card-body>
    </b-collapse>
  </b-card>
</template>

<script>
import Finder from '@/components/Finder.vue';
import Autocomplete from '@/components/Autocomplete.vue';
import moment from 'moment';

export default {
  props: ['value'],
  components: {
    Finder,
    Autocomplete,
  },
  data() {
    return {
      userauth: {},
      isRamoDisabled: false,
      emiDisabled: false,
      mostrarFechas: true,
      filterAccordionVisible: true,
      fechasRefacturaciones: false,
      selectProductoresOpen: false,
      selectProductoresOpenSize: 0,
      ramosHabilitados: [],
      tiposDeEndoso: [],
      nombreProductor: '',
      ventanaActual: { cod: 0, name: 'Pólizas y Endosos' },
      minDate: moment().subtract(2, 'year').format('YYYY-MM-DD'),
      tipoRamos: {
        seg_personas: [
          { text: 'ACCIDENTES PERSONALES', value: 10 },
          { text: 'VIDA INDIVIDUAL', value: 17 },
          { text: 'VIDA COLECTIVO', value: 18 },
          { text: 'VIDA OBLIGATORIO', value: 14 },
        ],
        property: [
          { text: 'INCENDIO', value: 1 },
          { text: 'CRISTALES', value: 5 },
          { text: 'ROBO', value: 9 },
          { text: 'INTEGRAL DE CONSORCIO', value: 12 },
          { text: 'SEGURO TECNICO', value: 21 },
          { text: 'COMBINADO FAMILIAR', value: 22 },
          { text: 'INTEGRAL DE COMERCIO', value: 23 },
          { text: 'RESP.CIVIL GENERAL', value: 81 },
        ],
        rc_profesional: [{ text: 'RESP.CIVIL PROFESIONAL', value: 80 }],
      },
      clearable: true
    };
  },
  methods: {
    reacciona () {
      // Esto solo esta para que reaccion el boton Aceptar y se habilite
      let temp = this.value.search;
      this.value.search = ' ';
      this.value.search = temp;
    },
    okDisabled() {
      const { tableIndex, ramo, refac_desde, refac_hasta, cod_agente } = this.value;
      if (tableIndex == 2) {
        return !ramo;
      }
      if ( (tableIndex == 3) && (!this.$role(['Productor'])) ) {
        return !cod_agente;
      }
      if (tableIndex == 4) {
        return !(refac_desde && refac_hasta);
      }
    },
    isProp(n) {
      return this.value.tableIndex === n;
    },
    setPolAnuladas() {
      this.ramosHabilitados = [
        {
          text: 'Otros Ramos y Responsabilidad Civil',
          value: 'rc_profesional',
        },
        {
          text: 'Seguros de Personas',
          value: 'PER',
        },
      ];
      this.fechasRefacturaciones = true;
      if (!this.value.ramo) {
        this.value.ramo = 'rc_profesional';
      }
      if (this.$role(['grupo norte'])) { this.value.ramo = 'rc_profesional'; this.value.subramo=80;}

      this.emiDisabled = true;
    },
    setPolRefacturaciones() {
      this.ramosHabilitados = [
        {
          text: 'Responsabilidad Civil',
          value: 'rc_profesional',
        },
        {
          text: 'Seguros de Personas',
          value: 'PER',
        },
      ];

      this.fechasRefacturaciones = true;
      if (!this.value.ramo) {
        this.value.ramo = 'rc_profesional';
      }
      if (this.$role(['grupo norte'])) { this.value.ramo = 'rc_profesional'; this.value.subramo=80;}

      this.emiDisabled = true;
    },
    setPolAvencer() {
      this.ramosHabilitados = [
        { text: 'Seguro de Personas', value: 'seguro_personas' },
        { text: 'Resto de Ramos', value: 'property' },
        { text: 'RC Profesional', value: 'rc_profesional' },
      ];
      if (this.$role(['grupo norte'])) { this.value.ramo = 'rc_profesional'; this.value.subramo=80;}

      this.emiDisabled = true;
    },
    setPolCondeuda() {
      this.ramosHabilitados = [
        { text: 'Seguro de Personas', value: 'seguro_personas' },
        { text: 'Resto de Ramos', value: 'property' },
        { text: 'RC Profesional', value: 'rc_profesional' },
      ];
      this.mostrarFechas = false;
      if (this.$role(['grupo norte'])) { this.value.ramo = 'rc_profesional'; this.value.subramo=80;}

    },
    setPolOthers() {
      this.ramosHabilitados = [
        { text: 'Seguro de Personas', value: 'seguro_personas' },
        { text: 'Resto de Ramos', value: 'property' },
        { text: 'RC Profesional', value: 'rc_profesional' },
      ];
      if (this.$role(['grupo norte'])) { this.value.ramo = 'rc_profesional'; this.value.subramo=80;}

    },
    resetFilters() {
      if (this.$role(['Productor'])) {
        // no hago nada porque siempre tiene que filtrar por su codigo
      }

      if (this.$role(['organizador'])) {
        // no hago nada, que cambie por otro productor si quiere
      }

      if (this.$role(['grupo norte'])) {
        // no hago nada, es como un organizador
      }

      if (this.$role(['empleado interno'])) {
        this.value.cod_organizador = '';
        this.value.cod_agente = '';
      }

      if (this.$role(['administrador'])) {
        this.value.cod_organizador = '';
        this.value.cod_agente = '';
      }

      this.value.search = '';

      //Resetea el checkbox y el valor del mismo
      this.value.checkDniCuitCuil = false;

      this.tiposDeEndoso = [];
      this.value.tipoendoso = null;

      this.value.subramo = null;
      if (this.$role(['grupo norte'])) {
        this.value.ramo = 'rc_profesional'; this.value.subramo=80;
      } else {
        this.value.ramo = 0;
      }

      this.value.refac_desde = null;
      this.value.refac_hasta = null;

      this.value.fec_emi_desde = null;
      this.value.fec_emi_hasta = null;

      this.value.vig_hasta = null;
      this.value.vig_desde = null;
    },
    setProp(n, name) {
      this.ventanaActual.cod = n;
      this.ventanaActual.name = name;
      this.emiDisabled = false;
      this.fechasRefacturaciones = false;
      this.mostrarFechas = true;

      this.resetFilters();

      if (n === 1) {
        this.setPolAvencer();
      } else if (n === 2) {
        // si estoy en "refacturaciones"
        this.setPolRefacturaciones();
      } else if (n === 3) {
        // si estoy en "polizas con deuda"
        this.setPolCondeuda();
      } else if (n === 4) {
        // si estoy en "pólizas anuladas"
        this.setPolAnuladas();
      } else {
        this.setPolOthers();
      }

      if (this.value.tableIndex !== n) {
        this.value.tableIndex = n;
        this.value.tableName = name;
        this.$emit('tableChange', { n, name });
      }
    },
    setOrganizador(item) {
      this.value.cod_agente = '';
      if (item==null) item = this.$store.state.auth.email;
      //console.log('esto va en item');
      //console.log(item);      
      this.$store.dispatch('getProductores', item);      
      //return this.$store.getters['productoresCartera'];
    },
    setProductor(item) {
      if (String(item).length) {
        ////console.log('se setea productor', item);
        //this.nombreProductor = item.value + ' - ' + item.text;
        this.$store.commit('unsetProductoresAsociados');
        this.$store.commit('setFiltroCodAgente', item);
      } else {
        ////console.log('se setea productor como nulo');
        //this.nombreProductor = null;
        if (this.$role(['Organizador'])) {
          this.$store.commit('setProductoresAsociados');
        } else {
          this.$store.commit('setFiltroCodAgente', '');
        }
      }
    },
    checkboxChanged(valCheck){
      this.value.checkDniCuitCuil = valCheck
    },
    dispatchSearch() {
      let rolUsuario = this.userauth.role.roles[0].id
      let rolesArray = [1,2,4] //Roles a los que no se les permite buscar polizas sin antes elegir un productor
      const filter = {};

      // limpio el filtrado borrando los parámetros que tienen valor ''      

      for (let index in this.value) {
        const value = this.value[index];
        if (value && value.length) {
          filter[index] = value;
        }
      }
      // aquí guardo el tipo de dato ingresado: numero o cadena

      if(this.value.cod_organizador){
        if(rolesArray.includes(rolUsuario) && this.productores.length > 0 && this.value.cod_agente == ""){
          this.$toast.warning("¡Es necesario elegir un productor para la busqueda de cartera!")
          return null
        }
      }

      this.filterAccordionVisible = false;

      this.$store.commit('setTipoBusqueda', filter.search);
      if (this.value.subramo) {
        filter.ramo = this.value.subramo;
      }

      //console.log(filter);
      this.$emit('change', { filter: filter });
    },
    onOpen() {
      this.selectProductoresOpen = true
        if(this.ventanaActual.cod == 0){
          this.selectProductoresOpenSize = 60
        }else if (this.ventanaActual.cod == 3){
          this.selectProductoresOpenSize = 190
        }else{
          this.selectProductoresOpenSize = 135
        }

      },
    onClose() {
      this.selectProductoresOpen = false
      this.selectProductoresOpenSize = 0
    },
  },
  computed: {
    isOrg() {
      return this.$role(['administrador', 'organizador', 'organizador limitado', 'Empleado interno']);
    },
    isEmpInt() {
      return this.$role(['administrador', 'Empleado interno']);
    },
    productores() {
      return this.$store.getters['productoresCartera'];
    },
    organizadores() {
      return this.$store.getters['organizadoresCartera'];
    },
    tiposEndoso() {
      return this.$store.getters['tiposDeEndosoCartera'];
    },
    disableFecEmi() {
      if ((this.value.vig_desde && this.value.vig_desde.length) || (this.value.vig_hasta && this.value.vig_hasta.length) || this.emiDisabled) {
        return true;
      }
      return false;
    },
    disableFecVig() {
      if ((this.value.fec_emi_desde && this.value.fec_emi_desde.length) || (this.value.fec_emi_hasta && this.value.fec_emi_hasta.length)) {
        return true;
      }
      return false;
    },
    disableFecVigDesde() {
      return this.value.ramo == 'PER' && this.value.tableIndex == 2;
    },
  },
  watch: {
    'value.ramo': function (newVal) {
      if (newVal == 'rc_profesional') {
        this.value.subramo = 80;
      } else {
        this.value.subramo = '';
      }
    },
  },
  mounted() {
    this.userauth = JSON.parse(sessionStorage.getItem('auth'));
    if (this.userauth.cod_agente!=9999) {
      this.value.cod_agente = this.userauth.cod_agente;
    }
    if (this.$role(['grupo norte'])) {
      this.isRamoDisabled=true;
    }
    //console.log(this.userauth);
    this.value.ramo = 'rc_profesional';
    const tindex = this.$store.state.filterCartera.tableIndex || 0;
    const tname = this.$store.state.filterCartera.tableName || 'Pólizas y Endosos';
    this.setProp(tindex, tname);

    if(this.userauth.role.roles[0].id == 2 && this.productores.length > 0) this.clearable = false
  },
};
</script>
